export const FETCH_COLOR_REQUEST = 'FETCH_COLOR_REQUEST';
export const FETCH_COLOR_SUCCESS = 'FETCH_COLOR_SUCCESS';
export const FETCH_COLOR_FAILURE = 'FETCH_COLOR_FAILURE';

export const ADD_COLOR_REQUEST = 'ADD_COLOR_REQUEST';
export const ADD_COLOR_SUCCESS = 'ADD_COLOR_SUCCESS';
export const ADD_COLOR_FAILURE = 'ADD_COLOR_FAILURE';

export const UPDATE_COLOR_REQUEST = 'UPDATE_COLOR_REQUEST';
export const UPDATE_COLOR_SUCCESS = 'UPDATE_COLOR_SUCCESS';
export const UPDATE_COLOR_FAILURE = 'UPDATE_COLOR_FAILURE';

export const DELETE_COLOR_REQUEST = 'DELETE_COLOR_REQUEST';
export const DELETE_COLOR_SUCCESS = 'DELETE_COLOR_SUCCESS';
export const DELETE_COLOR_FAILURE = 'DELETE_COLOR_FAILURE';

export const COLOR_FORM_ERROR = 'COLOR_FORM_ERROR';
export const COLOR_FORM_SUCCESS = 'COLOR_FORM_SUCCESS';
export const SET_COLOR_EDIT = 'SET_COLOR_EDIT';
export const CLEAR_COLOR_EDIT = 'CLEAR_COLOR_EDIT'; 